import { c as _c } from "react/compiler-runtime";
import { FaroCustomCheckbox } from "@components/common/faro-table/faro-custom-checkbox";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { Card, Tooltip } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { toggleItemSelection } from "@utils/array-utils";
import { navigateOnPlainClick } from "@utils/ui-utils";
import { useNavigate } from "react-router-dom";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
/**
 * Renders a list item card with image, title, subtitle, optional secondary text and an
 * optional three-dots menu.
 *
 * @template T - The type of item being rendered
 */
export function ListItemCardMobile(t0) {
  const $ = _c(43);
  const {
    item,
    image,
    imageFallbackSrc,
    imageAlt,
    title,
    href,
    onCardClick,
    subtitle,
    subtitleTooltip,
    secondaryText,
    actions,
    menuItems,
    variant: t1,
    isSelected: t2
  } = t0;
  const variant = t1 === undefined ? "standard" : t1;
  const isSelected = t2 === undefined ? false : t2;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  const itemId = item.id ?? item.identity ?? "";
  if (!itemId) {
    throw new Error("Item must have either 'id' or 'identity' property");
  }
  let t3;
  if ($[0] !== itemId || $[1] !== selectedRowIds) {
    t3 = selectedRowIds.includes(itemId);
    $[0] = itemId;
    $[1] = selectedRowIds;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isItemSelected = t3;
  const shouldShowCheckbox = selectedRowIds.length > 0;
  const hasMenuItems = (menuItems?.length ?? 0) > 0;
  const shouldShowActions = !shouldShowCheckbox && (hasMenuItems || actions !== undefined);
  const shouldShowActionsDivider = actions !== undefined && hasMenuItems;
  const isClickable = (!!href || !!onCardClick) && !shouldShowCheckbox;
  let t4;
  if ($[3] !== dispatch || $[4] !== itemId || $[5] !== selectedRowIds) {
    t4 = function handleCheckboxChange() {
      const newSelectedRowIds = toggleItemSelection(selectedRowIds, itemId);
      dispatch(setInitialFetchingItems(newSelectedRowIds));
    };
    $[3] = dispatch;
    $[4] = itemId;
    $[5] = selectedRowIds;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleCheckboxChange = t4;
  let t5;
  if ($[7] !== href || $[8] !== navigate || $[9] !== onCardClick) {
    t5 = function handleClick(event) {
      onCardClick?.();
      if (href) {
        navigateOnPlainClick(event, () => navigate(href));
      }
    };
    $[7] = href;
    $[8] = navigate;
    $[9] = onCardClick;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleClick = t5;
  let t6;
  if ($[11] !== actions || $[12] !== handleCheckboxChange || $[13] !== hasMenuItems || $[14] !== isItemSelected || $[15] !== item || $[16] !== menuItems || $[17] !== shouldShowActions || $[18] !== shouldShowActionsDivider || $[19] !== shouldShowCheckbox) {
    t6 = function getCardActions() {
      if (shouldShowCheckbox) {
        return <Stack onClick={_temp}><FaroCustomCheckbox checked={isItemSelected} onChange={handleCheckboxChange} controlSx={{
            visibility: "visible"
          }} /></Stack>;
      }
      if (!shouldShowActions) {
        return;
      }
      return <>{actions}{shouldShowActionsDivider && <SphereActionDivider />}{menuItems && hasMenuItems && <ListItemMenu item={item} menuItems={menuItems} />}</>;
    };
    $[11] = actions;
    $[12] = handleCheckboxChange;
    $[13] = hasMenuItems;
    $[14] = isItemSelected;
    $[15] = item;
    $[16] = menuItems;
    $[17] = shouldShowActions;
    $[18] = shouldShowActionsDivider;
    $[19] = shouldShowCheckbox;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const getCardActions = t6;
  const isImageUrl = typeof image === "string";
  const t7 = isSelected || isItemSelected;
  const t8 = variant === "outlined" && !shouldShowCheckbox ? "hover" : "always";
  const t9 = isClickable ? href : undefined;
  const t10 = isClickable ? handleClick : undefined;
  let t11;
  if ($[21] !== image || $[22] !== imageAlt || $[23] !== imageFallbackSrc || $[24] !== isImageUrl) {
    t11 = isImageUrl ? <ThumbnailImage src={image} fallbackSrc={imageFallbackSrc} alt={imageAlt} /> : undefined;
    $[21] = image;
    $[22] = imageAlt;
    $[23] = imageFallbackSrc;
    $[24] = isImageUrl;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = isImageUrl ? undefined : image;
  const t13 = subtitleTooltip ?? "";
  let t14;
  if ($[26] !== subtitle || $[27] !== t13) {
    t14 = <Tooltip title={t13}>{subtitle}</Tooltip>;
    $[26] = subtitle;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== getCardActions) {
    t15 = getCardActions();
    $[29] = getCardActions;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== secondaryText || $[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t14 || $[36] !== t15 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9 || $[40] !== title || $[41] !== variant) {
    t16 = <Card dataTestId="list-item-card-mobile" orientation="horizontal" variant={variant} selected={t7} actionsVisibility={t8} href={t9} onClick={t10} media={t11} avatar={t12} subheader={t14} title={title} footer={secondaryText} actions={t15} />;
    $[31] = secondaryText;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t14;
    $[36] = t15;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = title;
    $[41] = variant;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
}
function _temp(e) {
  return e.stopPropagation();
}